interface ModalFooterProps {
    onDismiss: () => void;
}

export const ModalFooter = ({ onDismiss }: ModalFooterProps) => (
    <div className="px-6 py-4 border-t flex justify-end">
        <button className="btn rounded-lg bg-stone-800 text-white px-5 py-2 text-sm" onClick={onDismiss}>
            Done
        </button>
    </div>
);
